import { ArrowBackIosNewRounded } from '@mui/icons-material';
import { Grid } from '@mui/material';
import { RoutalPalette } from '@nx-smartmonkey/ui';
import React, { useState } from 'react';
import { Text } from './Text';

interface StopCancelProps {
  titleIntId?: string;
  title?: string;
  headerStyle?: React.CSSProperties;
  textStyle?: React.CSSProperties;
  startHiddenIfAbove?: boolean;
  imageHeader?: React.ReactNode;
}

export const Dropdown = ({
  titleIntId,
  title,
  headerStyle,
  textStyle,
  startHiddenIfAbove,
  imageHeader,
  children,
}: React.PropsWithChildren<StopCancelProps>) => {
  const [showOptions, setShowOptions] = useState<boolean>(false);
  if (startHiddenIfAbove) setShowOptions(true);
  return (
    <Grid container item style={{ display: `flex`, flexDirection: `column`, flexWrap: `nowrap` }}>
      <Grid
        item
        style={{
          display: `Flex`,
          height: `30px`,
          backgroundColor: RoutalPalette.white,
          width: `100%`,
          justifyContent: `space-between`,
          alignItems: `center`,
          ...headerStyle,
        }}
        onClick={(e: any) => {
          setShowOptions(!showOptions);
        }}
      >
        <Grid display="flex">
          {imageHeader}
          {titleIntId ? (
            <Text style={{ fontSize: `16px`, marginLeft: `2px`, ...textStyle }} variant="label" intlId={titleIntId} />
          ) : (
            <Text style={{ fontSize: `16px`, marginLeft: `2px`, ...textStyle }} variant="label">
              {title}
            </Text>
          )}
        </Grid>
        <ArrowBackIosNewRounded
          style={{
            fill: `gray`,
            transform: showOptions ? `rotate(-90deg)` : `rotate(90deg)`,
            transition: `transform 0.3s ease`,
          }}
        />
      </Grid>
      {showOptions && (
        <Grid item style={{ transition: `height 0.3s ease` }}>
          {children}
        </Grid>
      )}
    </Grid>
  );
};
